var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0198 22.6123L27.5008 18.8338V13.75C27.5008 10.8326 26.3419 8.03473 24.279 5.97183C22.2161 3.90893 19.4182 2.75 16.5008 2.75C13.5834 2.75 10.7855 3.90893 8.72264 5.97183C6.65974 8.03473 5.50081 10.8326 5.50081 13.75V18.8338L2.98181 22.6123C2.84421 22.8195 2.76531 23.06 2.7535 23.3085C2.7417 23.5569 2.79744 23.8038 2.91478 24.0231C3.03213 24.2424 3.2067 24.4258 3.41994 24.5538C3.63318 24.6818 3.87711 24.7496 4.12581 24.75H28.8758C29.1245 24.7496 29.3685 24.6818 29.5817 24.5538C29.7949 24.4258 29.9695 24.2424 30.0868 24.0231C30.2042 23.8038 30.2599 23.5569 30.2481 23.3085C30.2363 23.06 30.1574 22.8195 30.0198 22.6123Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5009 30.25C17.7201 30.2511 18.9049 29.8462 19.8684 29.0993C20.8319 28.3524 21.5193 27.3059 21.8222 26.125H11.1797C11.4825 27.3059 12.17 28.3524 13.1335 29.0993C14.097 29.8462 15.2818 30.2511 16.5009 30.25Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.40c694a35a92cb8a868b41258345bb1d.svg";
export { ForwardRef as ReactComponent };